import * as React from 'react';

import { mergeStyles } from '@cian/utils';
import { Button, ButtonSize } from '@cian/button-component';
import { OutsideClick } from '@cian/outside-click-component';
import { ICountrysidePromoItem, IPhoneSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import {
  PromotionsSaleIcon,
  PromotionsBonusIcon,
  PromotionsMortgageIcon,
  CloseIcon,
} from '../../common/components/icons';
import { IAnalyticsData, IVillageBuilder } from '../../types';
import { trackOpenPromotionsPhoneClick, trackPromotionsIconClick } from '../../utils/tracking/promotions';

import * as styles from './PromotionItem.css';

interface IPromotionItemProps {
  item: ICountrysidePromoItem;
  phone: IPhoneSchema | null;
  builder?: IVillageBuilder;
  position: number;
  analyticsData: IAnalyticsData;
}

interface IPromotionItemState {
  isPopupOpen: boolean;
  isPhoneVisible: boolean;
  popupOnTop: boolean;
}

const ICONS = {
  sale: <PromotionsSaleIcon className={styles['svg-block']} />,
  bonus: <PromotionsBonusIcon className={styles['svg-block']} />,
  mortgage: <PromotionsMortgageIcon className={styles['svg-block']} />,
};

export class PromotionItem extends React.Component<IPromotionItemProps, IPromotionItemState> {
  public state = {
    isPopupOpen: false,
    isPhoneVisible: false,
    popupOnTop: false,
  };

  private itemRef = React.createRef<HTMLDivElement>();

  public render() {
    const { item, phone } = this.props;
    const { isPopupOpen, isPhoneVisible, popupOnTop } = this.state;

    return (
      <div ref={this.itemRef} className={styles['promotion']}>
        <div className={styles['promotion-item']}>
          <div
            {...mergeStyles(
              styles['promotion-item_inner'],
              item.description && styles['clickable'],
              item.description && styles[`item-${item.type}`],
              isPopupOpen && styles['active'],
            )}
            onClick={this.onItemClick}
          >
            <div className={styles['icon']}>{this.renderIconByType()}</div>
            <div>
              <div className={styles['name']}>{item.name}</div>
              {item.endDate && <div className={styles['end_date']}>{item.endDate}</div>}
            </div>
          </div>
          {item.description && isPopupOpen && (
            <div {...mergeStyles(styles['popup'], popupOnTop && styles['popup--top'])}>
              <OutsideClick onOutsideClick={this.closePopup} rootElement={<div className={styles['popup-content']} />}>
                <div className={styles['description']}>
                  {this.renderDescriptionHeader()}
                  <div className={styles['description-text']}>{item.description}</div>
                  <div className={styles['close']} onClick={this.closePopup}>
                    <CloseIcon />
                  </div>
                </div>
                {phone && phone.number && (
                  <div className={styles['phone_button']}>
                    {isPhoneVisible ? (
                      <div className={styles['phone']}>
                        {phone.countryCode} {phone.number.replace(/(\d{3})(\d{3})(\d{2})(\d{2})/, '$1 $2-$3-$4')}
                      </div>
                    ) : (
                      <Button size={ButtonSize.S} onClick={this.handlePhoneCollapseButtonChange}>
                        Показать телефон
                      </Button>
                    )}
                  </div>
                )}
              </OutsideClick>
            </div>
          )}
        </div>
      </div>
    );
  }

  private renderDescriptionHeader = () => {
    const { builder } = this.props;
    if (!builder) {
      return null;
    }

    return (
      <div className={styles['description_header']}>
        {builder.logoUrl && (
          <div className={styles['description_header-left']}>
            <img className={styles['builder_logo']} src={builder.logoUrl} alt={builder.name || ''} />
          </div>
        )}
        {builder.name && <div className={styles['description_header-right']}>Застройщик «{builder.name}»</div>}
      </div>
    );
  };

  private renderIconByType = () => {
    const { type } = this.props.item;

    return ICONS[type];
  };

  private handlePhoneCollapseButtonChange = () => {
    setTimeout(() => {
      trackOpenPromotionsPhoneClick(this.props.analyticsData);

      this.setState({
        isPhoneVisible: true,
      });
    }, 0);
  };

  private onItemClick = () => {
    const {
      analyticsData: { offer, village },
      position,
      item: { description, type },
    } = this.props;
    const { isPopupOpen } = this.state;
    let popupOnTop = false;
    if (village) {
      trackPromotionsIconClick(type, position, offer.id, village.id);
    }

    if (!isPopupOpen && this.itemRef && this.itemRef.current) {
      const { current } = this.itemRef;
      const rect = current.getBoundingClientRect();
      const itemCenter = rect.top + rect.height / 2;

      if (itemCenter > window.innerHeight / 2) {
        popupOnTop = true;
      }
    }

    if (description) {
      this.setState({
        isPopupOpen: !isPopupOpen,
        isPhoneVisible: false,
        popupOnTop,
      });
    }
  };

  private closePopup = () => {
    this.setState({
      isPopupOpen: false,
      isPhoneVisible: false,
    });
  };
}
